<template> 
    <BaseLayout>  
        <div class="contact-container">
            <TitleModel
            :title="'联系方式'"
            :content="'欢迎通过以下方式联系我们，365天全年无休 竭诚为您服务。 我们的营业时间是11:00 AM - 01:00 AM，如需预约此时段外，请提前联系客服。'"
            /> 

            <!-- <div class="wp-relative"> 
              <IcoListModel :title="'OD家，澳洲No.1伴君品牌，12年口碑值得信赖，万千狼友的最佳选择。做服务，我们是认真的！'" />
            </div>  -->
          <CommContact />
        </div>
    </BaseLayout>
</template>
<script>
import BaseLayout from '@/components/BaseLayout.vue';
import TitleModel from '@/components/TitleModel.vue';
// import IcoListModel from '@/components/IcoListModel.vue';
import CommContact from '@/components/CommContact.vue';
export default {
  name: 'ContactPage',
  components: {
    BaseLayout,
    TitleModel,
    CommContact
  },
  data() {
    return {
      showModal: false,
    }
  }
}
</script>

<style lang="scss" scoped>
@import url('@/assets/css/commPage.scss');


</style>